import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, provide } from 'intact-vue-next';
import template from './group.vdt';
import { toggleArray } from '../utils';
import { BUTTON_GROUP } from './constants';
import { useConfigContext } from '../config';
var typeDefs = {
  vertical: Boolean,
  value: null,
  fluid: Boolean,
  checkType: ['none', 'radio', 'checkbox'],
  seperate: Boolean,
  btnWidth: [Number, String]
};
var defaults = function defaults() {
  return {
    checkType: 'none'
  };
};
export var ButtonGroup = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ButtonGroup, _Component);
  function ButtonGroup() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = ButtonGroup.prototype;
  _proto.init = function init() {
    provide(BUTTON_GROUP, this);
  };
  _proto.setValue = function setValue(v) {
    var _this$get = this.get(),
      checkType = _this$get.checkType,
      value = _this$get.value;
    if (checkType === 'radio') {
      this.set('value', v);
    } else if (checkType === 'checkbox') {
      value = toggleArray(value, v);
      this.set('value', value);
    }
  };
  return ButtonGroup;
}(Component);
ButtonGroup.template = template;
ButtonGroup.typeDefs = typeDefs;
ButtonGroup.defaults = defaults;